import type { SVGProps } from "react";
const SvgIconJobs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <circle cx={477} cy={397} r={80} />
    <path d="M541 502H413a96 96 0 0 0-96 96v14.85a209.7 209.7 0 0 0 320 0V598a96 96 0 0 0-96-96" />
    <path d="M824.68 789.32 695.43 660.07a285 285 0 1 0-35.36 35.36l129.25 129.25a25 25 0 0 0 35.36-35.36M242 477c0-129.58 105.42-235 235-235s235 105.42 235 235-105.42 235-235 235-235-105.42-235-235" />
  </svg>
);
export default SvgIconJobs;
